import React, { useEffect } from "react";

import Web3CommonAuthenticate from "@/components/Web3/Common/Authenticate";
import { SupButton, SupDialog, SupDialogBody, SupDialogFooter, SupDialogHeader, SupText, SupVaultUser, SupXCircle } from "@repo/core-ui";

import { useDynamicContext } from "@dynamic-labs/sdk-react-core";
import { useIsMounted } from "@/hooks/useIsMounted";
import useAnalytics from "@/hooks/useAnalytics";
import useReferrerHandler from "@/hooks/cred/useReferrerHandler";
import { notifyMessage } from "@/utils";

export default function CredReferrerHandler() {
  const handleOnLoad = useAnalytics();
  const { sdkHasLoaded } = useDynamicContext();

  const { handleSetCode, hasRef, isAuthenticated, handleReferrerRedeem, isLoading, handleCancel } = useReferrerHandler(
    () => {
      notifyMessage("Redemption Successful", "Successfully redeemed referral code", "success", <SupVaultUser />, "referrer-redeemed-success-toast", 20000);
    },
    () => {
      notifyMessage("Redemption Unsuccessful", `You have already been referred`, "error", <SupXCircle />, "referrer-redeemed-error-toast", 20000);
    }
  );

  const isMounted = useIsMounted();
  useEffect(() => {
    if (isMounted() && sdkHasLoaded) {
      handleSetCode();
    }
  }, [handleSetCode, isMounted, sdkHasLoaded]);

  useEffect(() => {
    if (isMounted() && sdkHasLoaded) {
      handleOnLoad();
    }
  }, [handleOnLoad, isMounted, sdkHasLoaded]);

  return (
    <SupDialog className="w-[24rem] max-w-full" open={hasRef} onClick={e => e.stopPropagation()} onClose={handleCancel}>
      <SupDialogHeader className="flex items-center justify-between">
        <SupText variant="subtitle1" weight="bold">
          Redeem Referral
        </SupText>
      </SupDialogHeader>
      <SupDialogBody>
        <SupText as="div" variant="subtitle2" className="mb-4">
          Please authenticate your wallet to redeem your referral
        </SupText>
      </SupDialogBody>
      <SupDialogFooter className="gap-2">
        <SupButton variant="outlined" fluid onClick={handleCancel} disabled={isLoading}>
          Cancel
        </SupButton>
        {isAuthenticated ? (
          <SupButton prefixIcon={<SupVaultUser className="h-6 w-6" />} className="whitespace-nowrap" fluid onClick={handleReferrerRedeem} disabled={isLoading}>
            Confirm Referral
          </SupButton>
        ) : (
          <Web3CommonAuthenticate />
        )}
      </SupDialogFooter>
    </SupDialog>
  );
}
